module.exports = __webpack_public_path__ + "static/media/2.Air Compressor.b584608a.jpg";